var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentPlateDispensed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83317 6.66665L3.83317 33.3333L37.1665 33.3333L37.1665 11.6667L32.1665 6.66666L3.83317 6.66665ZM35.4998 31.6667L35.4998 12.5L31.3332 8.33332L5.49984 8.33332L5.49984 31.6667L35.4998 31.6667Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1665 11.6667L28.8332 11.6667L28.8332 15L32.1665 15L32.1665 11.6667Z",
    fill: "#313131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4998 11.6667L22.1665 11.6667L22.1665 15L25.4998 15L25.4998 11.6667Z",
    fill: "#313131"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 11.6667L18.8332 11.6667L18.8332 15L15.4998 15L15.4998 11.6667Z",
    fill: "#313131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 11.6667L8.83317 11.6667L8.83317 15L12.1665 15L12.1665 11.6667Z",
    fill: "#313131"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 18.3333L8.83317 18.3333L8.83317 21.6667L12.1665 21.6667L12.1665 18.3333Z",
    fill: "#313131"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 18.3333L18.8332 18.3333L18.8332 21.6667L15.4998 21.6667L15.4998 18.3333Z",
    fill: "#313131"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4998 18.3333L22.1665 18.3333L22.1665 21.6667L25.4998 21.6667L25.4998 18.3333Z",
    fill: "#313131"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8332 18.3333L32.1665 18.3333L32.1665 21.6667L28.8332 21.6667L28.8332 18.3333Z",
    fill: "#313131"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8332 25L32.1665 25L32.1665 28.3333L28.8332 28.3333L28.8332 25Z",
    fill: "#313131"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4998 25L22.1665 25L22.1665 28.3333L25.4998 28.3333L25.4998 25Z",
    fill: "#313131"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8332 25L18.8332 28.3333L15.4998 28.3333L15.4998 25L18.8332 25Z",
    fill: "#313131"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 28.3333L12.1665 25L8.83317 25L8.83317 28.3333L12.1665 28.3333Z",
    fill: "#313131"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4638_357135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#FEFEFE",
    stroke: "#003D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95015 3L4.8641 7.52472L4.86543 7.52593C4.32389 8.21431 4 9.08787 4 10.0385C4 12.2597 5.76855 14.0604 7.95016 14.0604C10.1318 14.0604 11.9003 12.2597 11.9003 10.0385C11.9003 9.08787 11.5764 8.21431 11.0349 7.52593L11.0362 7.52472L7.95015 3Z",
    fill: "#003D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95016 3L4.72008 7.52472L4.72119 7.52593C4.26991 8.21431 4 9.08787 4 10.0385C4 12.7592 6.13215 14.0604 7.95016 14.0604C7.95016 14.0604 5.09727 12.3641 5.09727 10.0664C5.09727 7.30128 7.95016 3 7.95016 3Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6599 10.4335L12.4255 12.3726L12.426 12.3732C12.2094 12.6682 12.0798 13.0426 12.0798 13.45C12.0798 14.4019 12.7873 15.1737 13.6599 15.1737C14.5325 15.1737 15.24 14.4019 15.24 13.45C15.24 13.0426 15.1104 12.6682 14.8938 12.3732L14.8943 12.3726L13.6599 10.4335Z",
    fill: "#003D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6599 10.4335L12.4255 12.3726L12.426 12.3732C12.2094 12.6682 12.0798 13.0426 12.0798 13.45C12.0798 14.4019 12.7873 15.1737 13.6599 15.1737C13.6599 15.1737 12.6065 14.4466 12.6065 13.4619C12.6065 12.2769 13.6599 10.4335 13.6599 10.4335Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9309 13.6654L10.3137 14.9582L10.314 14.9585C10.2056 15.1552 10.1409 15.4048 10.1409 15.6764C10.1409 16.311 10.4946 16.8255 10.9309 16.8255C11.3672 16.8255 11.7209 16.311 11.7209 15.6764C11.7209 15.4048 11.6562 15.1552 11.5478 14.9585L11.5481 14.9582L10.9309 13.6654Z",
    fill: "#003D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9309 13.6654L10.3137 14.9582L10.314 14.9585C10.2056 15.1552 10.1409 15.4048 10.1409 15.6764C10.1409 16.311 10.4946 16.8255 10.9309 16.8255C10.9309 16.8255 10.4042 16.3409 10.4042 15.6844C10.4042 14.8943 10.9309 13.6654 10.9309 13.6654Z",
    fill: "#006AF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentPlateDispensed);
export default __webpack_public_path__ + "static/media/ExperimentPlateDispensed.048683a402badc750cb02cea09dcb864.svg";
export { ForwardRef as ReactComponent };